import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSiteMode } from "@/hooks/useSiteMode";

// Wrap public-catalog-facing routes. When the admin has flipped the public
// catalog OFF and the visitor is not logged in, we redirect to /login so the
// customer sees a clear sign-in surface (instead of a WhatsApp-OTP gate or
// an unexpected catalog wall). Logged-in users (any role) pass through
// regardless — they should keep working even while public access is paused.
export default function PublicAccessGuard({ children }) {
  const { user, loading: authLoading } = useAuth();
  const { loading: modeLoading, publicCatalogEnabled } = useSiteMode();

  // Tiny "checking…" splash so we don't flash the catalog UI before deciding.
  if (authLoading || modeLoading) {
    return (
      <div
        className="min-h-[40vh] flex items-center justify-center"
        data-testid="public-access-guard-loading"
      >
        <span className="font-serif text-[#D62828] text-xl">Loading…</span>
      </div>
    );
  }
  if (!publicCatalogEnabled && !user) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
